import { isTodayWorkClient } from './clientAttribution'

/** 仅用于权益事件，不注册全局 string3，避免覆盖其他事件的槽位含义。 */
export function teamRightsClientTrackingProps(): { string3?: string } {
  return isTodayWorkClient() ? { string3: 'todaywork_desktop' } : {}
}

/** 展示来源独立于订单 source；旧客户端和未登记入口保留原来的默认值。 */
export function resolveEmbedVipTrackSource(raw: string | null): string {
  if (
    isTodayWorkClient() &&
    (raw === 'todaywork_team_rights' || raw === 'todaywork_privileges')
  ) {
    return raw
  }
  return '我的积分弹窗'
}
